// Copyright (c) 2020-2023 dātma, inc™
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { ehrBaseUrl } from '@/settings'

const diagnosisBaseUrl = `${ehrBaseUrl}/diagnosis`
const idBaseUrl = `${ehrBaseUrl}/patient_id`

const patientQuery = 'patient_id'
const idQuery = 'MRN'

const callPatientEhrWithTimeout = async (data, query, baseUrl) => {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${baseUrl}?${query}=${encodeURIComponent(data)}`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}

export const diagnose = async (patientId) => await callPatientEhrWithTimeout(patientId, patientQuery, diagnosisBaseUrl)

export const getId = async (mrn) => await callPatientEhrWithTimeout(mrn, idQuery, idBaseUrl)
